import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapeHorizontalPool extends Shape {
    width = 180;
    height = 200;
    includeText = false;

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);

        canv.ctx.moveTo(x + w * 0.22, y);
        canv.ctx.lineTo(x + w * 0.22, y + h);

        canv.ctx.moveTo(x + w * 0.44, y);
        canv.ctx.lineTo(x + w * 0.44, y + h);

        canv.ctx.moveTo(x, y + h * 0.33);
        canv.ctx.lineTo(x + w, y + h * 0.33);

        canv.ctx.moveTo(x, y + h * 0.66);
        canv.ctx.lineTo(x + w, y + h * 0.66);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="${stroke}" fill="${fill}" stroke-linejoin="round" d="M6.88 2v20M3 15.34V22h18v-6.66m-18 0V2h18v13.34m-18 0h18M3 8.7h18M10.9 2v20"/>
            </svg>
        `;
    }
}
